import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ReferenceDocument } from "@shared/models/cat.model";
import { ClaimReferenceDetails } from "../../model/claim-reference-details";
import { UserAddedAnchorResult } from "@shared/models/common";


@Component({
    selector: 'claim-references-editor',
    templateUrl: './claim-references-editor.component.html',
    styleUrls: ['./claim-references-editor.component.scss'],
    standalone: false
})
export class ClaimReferencesEditor implements OnInit {

    @Input({required: true}) claimReference!: ClaimReferenceDetails;
    @Input() catVersionId!: number;
    @Input() mode: 'create' | 'edit' | 'view' = 'create';
    
    @Input() claimReferences: ClaimReferenceDetails[] | null = null;
    @Input() filteredRefDocs: ReferenceDocument[] = [];
    @Input() refDocs: ReferenceDocument[] = [];

    @Output() removeClaimReference = new EventEmitter<ClaimReferenceDetails>();

    
    selectedRefDoc?: ReferenceDocument;

    anchors: UserAddedAnchorResult[] | null = null;
    selectedAnchor: UserAddedAnchorResult | null = null;
    //showAnchors: boolean = false;
    showAddContextDropdown: {
        value: boolean
    } = {
            value: false
        };

    constructor() {}

    ngOnInit(): void {

        if (this.mode !== 'create') {

            this.selectedRefDoc = this.refDocs.find((refDoc) => refDoc.docId == this.claimReference.refDocId);
        }

    }
    
    onRefDocSelect() {
        
        if (!this.selectedRefDoc) {
            
            return;
        }
        const refDoc = this.selectedRefDoc;
        // add ref doc to claim references
        // display its anchors
        // send request for anchors
        let index = this.filteredRefDocs.findIndex(doc => doc == this.selectedRefDoc);
        if (index != -1) {
            this.filteredRefDocs.splice(index, 1);
        }
        let mappedReferenceText = refDoc.mappedReferenceTexts;
        let referenceText = refDoc.docName;
        if (mappedReferenceText && mappedReferenceText.length > 0) {

            let mappedRefText = mappedReferenceText.find((refText) => refText != "" && refText != null);
            if (mappedRefText != undefined) {

                referenceText = mappedRefText;

            }
        }

        this.claimReference.refDocId = refDoc.docId;
        this.claimReference.refPhraseText = referenceText;
        this.claimReference.anchors = [];
        this.claimReference.isConsistencyGenerated = false;


    }

    removedAnchor() {

        this.showAddContextDropdown.value = false;

    }


    toggleAnchorsDisplay() {

        this.showAddContextDropdown.value = !this.showAddContextDropdown.value;

    }

    removeReference() {
        
        this.removeClaimReference.emit(this.claimReference);
        if (this.selectedRefDoc) {

            this.filteredRefDocs.push(this.selectedRefDoc);
        }
        
    }   
} 